import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
import { AuthService } from '../auth.service';

@Component({
  selector: 'login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  form!: UntypedFormGroup;
  loading = false;
  submitted = false;
  private returnUrl!: string;
  errorMessage!: string;
  hide = true;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
  ) {
    // redirect to home if already logged in
    if (this.authService.currentUserValue) {
      if (this.returnUrl) {
        this.router.navigate(this.returnUrl.split('/'));
      } else {
        this.router.navigate(['/']);
      }
    }
  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      email: ['', Validators.required],
      password: ['', Validators.required],
    });

    // get return url from route parameters or default to '/'
    this.returnUrl = decodeURI(this.route.snapshot.queryParams['returnUrl'] ?? '/');
    this.errorMessage = decodeURI(this.route.snapshot.queryParams['errorMessage'] ?? '');
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.form.controls;
  }

  onSubmit() {
    this.submitted = true;

    if (this.form.invalid) {
      return;
    }

    this.loading = true;
    this.authService
      .login(this.f.email.value.trim(), this.f.password.value)
      .pipe(first())
      .subscribe(
        (data) => {
          this.router.navigate(this.returnUrl.split('/'));
        },
        (error) => {
          console.log(error);
          alert(error?.error?.response?.message);
          this.loading = false;
        },
      );
  }
}
